<template>
<div class="vue-app">
    <div class="container form-container">
        <div class="row">
            <div class="col-12 col-md-4 my-3">
                <div class="patient-education-content">
                    <h2 :class="post_title_h_style">{{ post_title }}</h2>
                    <div v-html="post_description"></div>
                </div>
            </div>
            <div class="col-12 col-md-8 my-3">
                <form id="patient-education-search-form">
                    <div class="form-row">
                        <div class="col-12 col-md-6 mb-3 mb-md-0">
                            <h3 class="h5">Search by Keyword</h3>
                            <input id="keyword" type="text" class="form-control" placeholder="Keyword" v-model="form.keyword" ref="keyword">
                        </div>
                        <div class="col-12 col-md-6 mb-3 mb-md-0">
                            <h3 class="h5">Search by Cancer Type</h3>
                            <multiselect
                                id="search-cancer-type"
                                ref="search_cancer_type"
                                v-model="form.cancer_type"
                                :options="cancer_types"
                                :multiple="true"
                                placeholder="Cancer Type:"
                                :close-on-select="false"
                                :clear-on-select="true"
                                selectLabel="Press enter or click to select"
                                deselectLabel="Press enter or click to remove"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-row mt-3">
                        <button type="submit" @click.prevent="searchResults(true)" class="btn btn-primary mr-1">Search</button>
                        <button type="submit" @click.prevent="resetForm()" class="btn btn-dark">Reset Form</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ApiCalls from "../../api/apiServices"

export default {
    data() {
        return {
            post_title: window.patient_stories_search.form_title ? window.patient_stories_search.form_title : '',
            post_title_h_style: window.patient_stories_search.form_title_h_style ? window.patient_stories_search.form_title_h_style : 'h4',
            post_description: window.patient_stories_search.form_description ? window.patient_stories_search.form_description : '',
            form: {
                keyword: null,
                cancer_type: [],
            },
            cancer_types: [],
            dropdownHeight: 200,
        }
    },
    methods: {
        retrieveDropdowns(){
            this.getDropdownValues(window.cancer_types_json).then((results) => {
                if( results != null ) {
                    Object.values(results).forEach(result => {
                        let text = result.text
                        let cancer_type = {
                            text: text,
                            value: text,
                            id: result.id
                        }
                        this.cancer_types.push(cancer_type)
                    })
                }
            })
        },
        getDropdownValues(type){
            return new Promise((resolve, reject) => {
                resolve(type)
            })
        },
        searchResults(scroll = false){
            let results = document.querySelectorAll('.story-search-result');
            let count = 0;
            [...results].forEach((result) =>{
                let valid_result = this.filterCard(result)
                if (!valid_result){
                    result.classList.remove('active')
                }
                if (valid_result && !result.classList.contains('active')){
                    result.classList.add('active')
                    count++;
                }
            })
            if (count) {
                document.querySelector(".no-results").classList.add("d-none");
            } else {
                document.querySelector(".no-results").classList.remove("d-none");
            }
            if (scroll) {
                document.querySelector('.vue-search-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        filterCard(card){
            let form_type = this.form.cancer_type
            let card_type_arr = card.dataset.type.split(";")
            let card_summary = card.querySelector('.card-text').innerText + " " + card.querySelector('.card-title').innerText
            card_summary = card_summary.toLowerCase();
            let filtered_type = false
            let filtered_keyword = true
            if(form_type.length) {
                card_type_arr.forEach(function(type){
                    form_type.forEach(function(f_type){
                        if(type == f_type.value || f_type.value == null) {
                            filtered_type = true
                        }
                    })
                })
            } else {
                filtered_type = true
            }
            if(this.form.keyword !== null) {
                let terms = this.form.keyword.split(' ')
                terms.forEach((term) => {
                    if (!card_summary.includes(term.toLowerCase())) {
                        filtered_keyword = false;
                    }
                })
            }
            return (filtered_type && filtered_keyword)
        },
        resetForm(){
            this.form = {
                keyword: null,
                cancer_type: []
            }
        },

        findSpacingTarget() {
            return this.$el.querySelector(".form-container")
        },
        findPositionTop(elem) {
            let offsetTop = 0;
            do {
                offsetTop += elem.offsetTop
            } while (elem = elem.offsetParent)
            return offsetTop;
        },

        onMultiselectOpen(id) {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                let dropdownField = this.$el.querySelector("#" + id).closest('.multiselect')
                let ddtop = this.findPositionTop(dropdownField) - this.findPositionTop(spacingTarget)
                spacingTarget.style.marginBottom = Math.max(0, (ddtop + dropdownField.offsetHeight + this.dropdownHeight) - spacingTarget.offsetHeight) + "px"
            }
        },

        onMultiselectClose() {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                spacingTarget.style.marginBottom = 0
            }
        },
    },
    mounted(){
        ["search_cancer_type"].forEach((item) => {
          this.$refs[item].$refs.search.setAttribute("autocomplete", "off");
        })
        this.retrieveDropdowns()
    }
}
</script>
